import { Stack, Typography } from '@mui/material';
import { Chip } from '@side/pantry';
import { capitalize } from 'lodash';
import type { HTMLAttributes } from 'react';
import { highlightSubstring } from '@/common/utils/string';
import type { SearchResult } from '@/views/Home/hooks';

type Props = HTMLAttributes<HTMLLIElement> & {
  option: SearchResult;
  searchTerm?: string;
  index: number;
};

export const DropdownOption = ({
  option,
  searchTerm,
  index,
  ...optionProps
}: Props) => {
  const { address, contacts, id, representation } = option;

  return (
    <Stack
      key={id}
      data-pendo-id={`search-result-row-${index}`}
      component="li"
      sx={{
        flexWrap: 'noWrap',
        alignSelf: 'flex-start',
        width: '100%',
      }}
      {...optionProps}
    >
      <Typography
        variant="body2"
        sx={{
          pl: 1,
          pt: 0.75,
          pb: contacts ? 0.5 : 0.75,
          wordBreak: 'break-word',
          alignSelf: 'flex-start',
        }}
        // biome-ignore lint/security/noDangerouslySetInnerHtml: Used for highlighting
        dangerouslySetInnerHTML={{
          __html: searchTerm
            ? highlightSubstring(address, searchTerm)
            : address,
        }}
      />
      {(!!contacts || !!representation) && (
        <Stack
          direction="row"
          sx={{
            alignSelf: 'flex-start',
            alignItems: 'center',
            pl: 1,
            maxWidth: '100%',
          }}
        >
          {representation && (
            <Chip
              label={capitalize(representation)}
              variant="outlined"
              color="primary"
              size="small"
              sx={{ width: 'fit-content', mr: 0.5 }}
            />
          )}
          {contacts && (
            <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
              {contacts}
            </Typography>
          )}
        </Stack>
      )}
    </Stack>
  );
};
